<template>
  <div class="hotel-conteiner">
    <div class="hotel-bg">
      <img class="img" :src="bgImage">
    </div>

    <div class="hotel-content">
      <!-- <div class="hotel-title">酒店预订服务声明</div> -->
      <div class="hotel-desc">
        <div class="hotel-title">酒店预订服务声明</div>
        <p class="desc-text"> 组委会为广大参展客商提供酒店预订服务，所推荐的第三方酒店预订服务，仅作为信息提供、低价保障及订房便利，并非预订服务的提供者。
        </p>
        <p class="desc-text">
          您在使用第三方酒店预订服务时，请仔细阅读相关条款，并遵守条款约定，包括但不限于酒店位置、支付取消政策、入住和退房时间、发票开具等。如因服务存在任何问题或纠纷，将由您和服务提供方协商解决，组委会对此不承担任何法律责任。
        </p>
      </div>
      <div class="hotel-tips">
        <img :src="tipsImage">
      </div>
      <div class="hotel-entry">
        <div class="hotel-btn" @click="onEntry(1)">
          <img :src="entryFirst">
        </div>
        <div class="hotel-btn" @click="onEntry(2)">
          <img style="display:block;width:100%;height:100%" :src="entrySecond" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const t = Date.now()
      return {
        bgImage: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/hotel/hotel_bg.png?t=" + t,
        tipsImage: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/hotel/hotel_tips.png?t=" + t,
        entryFirst: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/hotel/hotel_entry_1.png?t=" + t,
        entrySecond: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/hotel/hotel_entry_2.png?t=" + t,
      }
    },
    created() {
      window.I.$RangersEvent('hotel_view')
    },
    methods: {
      onEntry(type) {
        if (type === 1) {
          window.I.$RangersEvent('hotel_view_click_1', { name: '酒店预定入口一' })
          window.location.href = 'https://sdlm.cn/Mobile/Hotel/Exhibition/1189'
        } else if (type === 2) {
          window.I.$RangersEvent('hotel_view_click_2', { name: '酒店预定入口二' })
          window.location.href = 'https://wchat.miceclouds.com/m/hotelList.htm?activityId=2355&userAccountId='
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.hotel-conteiner {
  width: 100%;
  position: relative;
}
.hotel-bg {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
.hotel-content {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 16%;
  .hotel-title {
    // font-weight: 500;
    // font-size: 20px;
    // color: #FF1EA0;
    // border-radius: 30px;
    // margin: 0 auto;
    // text-align: center;


    font-weight: 700;
    font-size: 18px;
    margin-bottom: 6px;
    color: #FF1EA0;
    line-height: 25px;
    text-align: center;
  }
  .hotel-desc {
    padding: 14px 6px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 4px;
    margin-top: 16px;
    .desc-text {
      margin: 0;
      padding: 0;
      font-weight: 520;
      font-size: 14px;
      color: #FF1EA0;
      text-indent: 2em;
      line-height: 25px;
    }
  }
  .hotel-tips{
    width: 90%;
    margin: 24px auto 15px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .hotel-entry {
    margin-top: 15px;
    .hotel-btn {
      width: 100%;
      margin-bottom: 12px;
      position: relative;
      #launch-btn {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
      img {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
